import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EMPTY, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { StateService } from "../../services/store/state/state.service";
import { flowMetaDataAction, flowModeAction } from "../actions/flow.action";
import { selectFlowMetaData, selectFlowModeState } from "../selectors/flow.selector";

@Injectable()
export class FlowEffects {

    loadFlowMode$ = createEffect(() => 
    this.actions$.pipe(
        ofType(flowModeAction),
        switchMap(() => this.store.select(selectFlowModeState).pipe(
            map((mode) => { this.stateService.setFlowMode(mode) }),
            catchError(() => {
                return of(EMPTY);
            })
        ))), { dispatch: false });

    loadFlowMetaData$ = createEffect(() => 
    this.actions$.pipe(
        ofType(flowMetaDataAction),
        switchMap(() => this.store.select(selectFlowMetaData).pipe(
            map((metaData) => { this.stateService.setFlowMetaData(metaData) }),
            catchError(() => {
                return of(EMPTY);
            })
        ))), { dispatch: false });

    constructor(
        private actions$: Actions, 
        private store: Store,
        private stateService: StateService){}
}

